//import { IntercomContext } from "contexts/IntercomContext";
//import { useIntercom } from "react-use-intercom";
import { useClient } from "@adamlip/okeoke.client"
import { UserContext } from "contexts/UserContext"
import { useContext } from "react"
import MoreMenuList from "./MoreMenuList"
import LoginButton from "./LoginButton"
import BrandDisplay from "./BrandDisplay"
import UserName from "./UserName"
import { ScrollShadow } from "@nextui-org/react"
import { AppParamsContext } from "contexts/AppParamsContext"

export default function MoreMenu({ onSelect }) {
  const { languageCode } = useClient()
  const { appParams } = useContext(AppParamsContext)
  //const { hide, show, isOpen } = useIntercom();
  //const { unreadMessagesCount } = useContext(IntercomContext);

  const { userData, userLoggedIn } = useContext(UserContext)
  const style =
    appParams?.navigation?.appMenuSettings?.enabled !== true
      ? appParams?.styles?.moreMenu?.style
      : appParams?.navigation?.appMenuSettings?.layout
  // const handleIntercomClick = () => {
  //   if (isOpen) {
  //     hide();
  //     if (window.Intercom) {
  //       window.Intercom("update", {
  //         hide_default_launcher: true,
  //       });
  //     }
  //   } else {
  //     if (window.Intercom) {
  //       window.Intercom("update", {
  //         hide_default_launcher: false,
  //       });
  //     }
  //     show();
  //   }
  // };
  //console.log(appParams);

  return (
    <div
      className={`md:max-w-[500px] md:m-auto ${
        appParams?.styles?.fonts?.capitalize ? "font-bold uppercase" : ""
      } flex flex-col gap-2 h-full overflow-hidden ${
        appParams?.styles?.topBottomBar?.layout === "floating"
          ? "pb-[100px]"
          : "pb-[0px]"
      }`}
    >
      {userData?.email != null && (
        <UserName
          userData={userData}
          languageCode={languageCode}
          userLoggedIn={userLoggedIn}
        />
      )}
      <ScrollShadow
        className={`overflow-auto flex gap-3 px-4 pt-2 pb-6 ${
          style === "grid" ? "flex-row flex-wrap justify-center" : "flex-col"
        }`}
      >
        <MoreMenuList onSelect={onSelect} />
      </ScrollShadow>
      <LoginButton />
      <BrandDisplay />
      {/* {appParams?.styles?.global?.showIntercom && (
        <div className="w-full flex items-center justify-center relative">
          <Button
            onClick={handleIntercomClick}
            color={isOpen || unreadMessagesCount > 0 ? "primary" : "default"}
            className={`${
              appParams?.styles?.fonts?.capitalize
                ? "font-extrabold uppercase"
                : ""
            } rounded-[var(--order-button-border-radius)]`}
          >
            {getValue("app_v2_support")}{" "}
            {unreadMessagesCount > 0 && `(${unreadMessagesCount})`}
          </Button>
        </div>
      )} */}
    </div>
  )
}
